export default "__VITE_ASSET__DSEV9O98__"